<template>
	<div>
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/admin/index' }">我的工作台</el-breadcrumb-item>
			<el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
		</el-breadcrumb>
		<div style="height: 20px;"></div>
		<el-card shadow="always">
			<router-view />
		</el-card>
	</div>
</template>
<style>
	.row .col-md-6 {
		padding-bottom: 25px;
	}

	.w-100 {
		padding-left: 15px;
	}
</style>

<script>
	export default {
		data() {
			return {}
		},
		mounted() {
			this.$admin.getToken();
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/admin/_layout/template_a.vue